module.exports = __webpack_public_path__ + "img/backyard-pond.e6514982.webp";